export default __webpack_public_path__ + "static/media/frontini-logo-single.b9d70ec4.svg";